export default{
    actions: {
      
    },
    mutations: {
    addpostfiltirobvs(state, newpost){
        if(newpost.length) state.postobvs.push(newpost);
        else state.postobvs=newpost;   
    },
    addsetgorod(state, newpost){
        state.gorod=newpost;
    },
    addsetgorod_text(state, newpost){
        state.gorod_text=newpost;
    },
    addsetkateg(state, newpost){
        state.kateg=newpost;
    },
    addsetkateg_text(state, newpost){
        state.kateg_text=newpost;
    },
    addsetpodkateg(state, newpost){
        state.podkateg=newpost;
    },
    addsetpodkateg_text(state, newpost){
        state.podkateg_text=newpost;
    },
    addsetmarka(state, newpost){
        state.marka=newpost;
    },
    addsetmarka_text(state, newpost){
        state.marka_text=newpost;
    },
    addsetmodel(state, newpost){
        state.model=newpost;
    },
    addsetmodel_text(state, newpost){
        state.model_text=newpost;
    },
    addsetgod_ot(state, newpost){
        state.god_ot=newpost;
    },
    addsetgod_do(state, newpost){
        state.god_do=newpost;
    },
    addsetsena_ot(state, newpost){
        state.sena_ot=newpost;
    },
    addsetsena_do(state, newpost){
        state.sena_do=newpost;
    },
    addsetkeyworld(state, newpost){
        state.keyworld=newpost;
    },
    addsetprobeg(state, newpost){
        state.probeg=newpost;
    },
    addsetcolor(state, newpost){
        state.color=newpost;
    },
    addsetcolor_text(state, newpost){
        state.color_text=newpost;
    },
    addsettopliva(state, newpost){
        state.topliva=newpost;
    },
    addsettopliva_text(state, newpost){
        state.topliva_text=newpost;
    },
    addsetkarobka(state, newpost){
        state.karobka=newpost;
    },
    addsetkarobka_text(state, newpost){
        state.karobka_text=newpost;
    },
    addsetkuzov(state, newpost){
        state.kuzov=newpost;
    },
    addsetkuzov_text(state, newpost){
        state.kuzov_text=newpost;
    },
    addsettip(state, newpost){
        state.tip=newpost;
    },
    addsettip_text(state, newpost){
        state.tip_text=newpost;
    },
    
    addsetid(state, newpost){
        state.id=newpost;
    },
    unsertset(state, newpost){
        state.id=newpost;
        state.gorod="";
        state.gorod_text="";
        state.kateg="",
        state.kateg_text="";
        state.podkateg="";
        state.podkateg_text="";
        state.marka="";
        state.marka_text="";
        state.model="";
        state.model_text="";
        state.god_ot="";
        state.god_do="";
        state.sena_ot="";
        state.sena_do="";
        state.keyworld="";
        state.kuzov="";
        state.kuzov_text="";
        state.color="";
        state.color_text="";
        state.topliva="";
        state.topliva_text="";
        state.karobka="";
        state.karobka_text="";
        state.probeg="";
        state.tip="";
        state.tip_text="";
    }
    },
    state: {
       postobvs: [],
        id:"",
        gorod:"",
        gorod_text:"",
        kateg:"",
        kateg_text:"",
        podkateg:"",
        podkateg_text:"",
        marka:"",
        marka_text:"",
        model:"",
        model_text:"",
        god_ot:"",
        god_do:"",
        sena_ot:"",
        sena_do:"",
        keyworld:"",
        kuzov:"",
        kuzov_text:"",
        color:"",
        color_text:"",
        topliva:"",
        topliva_text:"",
        karobka:"",
        karobka_text:"",
        probeg:"",
        tip:"",
        tip_text:"",

    },
    getters:{
        getpostfiltirobvs(state){
            return state.postobvs
        }, 
        getsetgorod(state){
            return state.gorod
        },
        getsetgorod_text(state){
            return state.gorod_text
        }, 
        getsetkateg(state){
            return state.kateg
        },
        getsetkateg_text(state){
            return state.kateg_text
        },
        getsetpodkateg(state){
            return state.podkateg
        },
        getsetpodkateg_text(state){
            return state.podkateg_text
        },
        getsetmarka(state){
            return state.marka
        },
        getsetmarka_text(state){
            return state.marka_text
        },
        getsetmodel(state){
            return state.model
        },
        getsetmodel_text(state){
            return state.model_text
        },
        getsetgod_ot(state){
            return state.god_ot
        },
        getsetgod_do(state){
            return state.god_do
        },
        getsetsena_ot(state){
            return state.sena_ot
        },
        getsetsena_do(state){
            return state.sena_do
        },
        getsetkuzov(state){
            return state.kuzov
        },
        getsetkuzov_text(state){
            return state.kuzov_text
        },
        getsetcolor(state){
            return state.color
        },
        getsetcolor_text(state){
            return state.color_text
        },
        getsettopliva(state){
            return state.topliva
        },
        getsettopliva_text(state){
            return state.topliva_text
        },
        getsetkarobka(state){
            return state.karobka
        },
        getsetkarobka_text(state){
            return state.karobka_text
        },
        getsettip(state){
            return state.tip
        },
        getsettip_text(state){
            return state.tip_text
        },
        getsetprobeg(state){
            return state.probeg
        },
        getsetkeyworld(state){
            return state.keyworld
        },
        getsetid(state){
            return state.id
        }, 
    }
}